/*
  BimmerBrothers: Product-page checkbox add-ons for Minimog

  What it does
  - Renders checkbox UI via Liquid (Complementary products from Shopify Search & Discovery)
  - When customer clicks "Add to cart", checked add-ons are added alongside the main product

  Why this file uses a CAPTURE submit listener
  - Minimog binds `this.onSubmitHandler.bind(this)` inside `<product-form>`'s connectedCallback.
    If we patch the prototype later, the already-bound handler still points to the original.
  - A capture-phase submit handler reliably intercepts the form submit and can stop the
    original handler from running.
*/
(function () {
  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function safeGet(obj, path) {
    try {
      return path.split('.').reduce(function (acc, key) {
        return acc && acc[key];
      }, obj);
    } catch (e) {
      return undefined;
    }
  }

  function showNotice(targetEl, opts) {
    try {
      var Notification = safeGet(window, 'MinimogTheme.Notification');
      if (Notification && typeof Notification.show === 'function') {
        Notification.show(opts);
      }
    } catch (e) {}
  }

  function getCartJSON() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    if (typeof window.fetchJSON === 'function') return window.fetchJSON(root + 'cart.json');
    return fetch(root + 'cart.json', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function updateCartBubble(count) {
    try {
      document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.classList.remove('m:hidden');
        } else {
          el.classList.add('m:hidden');
        }
      });
    } catch (e) {}
  }

  function buildMultiAddFormData(form, checked) {
    // Ensure variant id input is included
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.disabled = false;

    var fd = new FormData(form);
    var mainId = fd.get('id');
    var mainQty = toInt(fd.get('quantity') || '1', 1);

    var req = new FormData();
    req.append('items[0][id]', mainId);
    req.append('items[0][quantity]', mainQty);

    // Selling plan (subscriptions) if present
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) req.append('items[0][selling_plan]', sellingPlan);

    // Copy line item properties to main item
    try {
      fd.forEach(function (value, key) {
        if (!value) return;
        var m = key.match(/^properties\[(.+)\]$/);
        if (m) {
          req.append('items[0][properties][' + m[1] + ']', value);
        }
      });
    } catch (e) {}

    // Add-ons: qty 1 each
    var idx = 1;
    checked.forEach(function (cb) {
      var vid = cb.getAttribute('data-bb-addon-variant-id') || cb.value;
      if (!vid) return;
      req.append('items[' + idx + '][id]', vid);
      req.append('items[' + idx + '][quantity]', 1);
      idx += 1;
    });

    return req;
  }

  function handleMultiAdd(productFormEl, form, checked) {
    var settings = window.MinimogSettings || {};
    var strings = window.MinimogStrings || {};

    // Spinner on
    try {
      if (productFormEl && typeof productFormEl.toggleSpinner === 'function') productFormEl.toggleSpinner(true);
    } catch (e) {}

    // Validate required fields (Minimog helper)
    try {
      if (typeof window.validateForm === 'function') {
        var issues = window.validateForm(form.closest('.m-main-product--info'));
        if (issues && issues.length > 0) {
          try {
            if (productFormEl && typeof productFormEl.toggleSpinner === 'function') productFormEl.toggleSpinner(false);
          } catch (e2) {}
          showNotice(productFormEl, {
            target: (productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper) ? productFormEl.domNodes.errorWrapper : document.body,
            method: 'appendChild',
            type: 'warning',
            message: strings.requiredField || 'Please fill out required fields.',
            delay: 100
          });
          return;
        }
      }
    } catch (e3) {}

    var cfg = (typeof window.fetchConfig === 'function') ? window.fetchConfig('javascript') : { method: 'POST', headers: {} };
    cfg.headers = cfg.headers || {};
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    try {
      delete cfg.headers['Content-Type'];
    } catch (e4) {}

    var req = buildMultiAddFormData(form, checked);

    // Preserve Minimog section rendering for cart drawer
    try {
      if (productFormEl && productFormEl.cart && typeof productFormEl.cart.getSectionsToRender === 'function') {
        var sectionIds = productFormEl.cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
        req.append('sections', sectionIds);
        req.append('sections_url', window.location.pathname);
      }
    } catch (e5) {}

    cfg.body = req;

    var addUrl = safeGet(settings, 'routes.cart_add_url') || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js');

    fetch(addUrl, cfg)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status) {
          // Shopify error object
          try {
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartError, {
                source: 'product-form',
                productVariantId: (new FormData(form)).get('id'),
                errors: data.description,
                message: data.message
              });
            }
          } catch (e6) {}

          showNotice(productFormEl, {
            target: (productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper) ? productFormEl.domNodes.errorWrapper : document.body,
            method: 'appendChild',
            type: 'warning',
            message: data.message || data.description || 'Could not add to cart.',
            last: 3000,
            sticky: !(productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper)
          });
          productFormEl && (productFormEl.error = true);
          return;
        }

        // Success
        if (settings.use_ajax_atc) {
          if (productFormEl && productFormEl.cart && settings.enable_cart_drawer && typeof productFormEl.cart.renderContents === 'function') {
            productFormEl.cart.renderContents(data);
            showNotice(productFormEl, {
              target: productFormEl.cart.querySelector('m-cart-drawer-items'),
              method: 'prepend',
              type: 'success',
              message: strings.itemAdded || 'Added to cart',
              delay: 400
            });
            try {
              if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
              }
            } catch (e7) {}
          } else {
            showNotice(productFormEl, {
              target: (productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper) ? productFormEl.domNodes.errorWrapper : document.body,
              method: 'appendChild',
              type: 'success',
              message: strings.itemAdded || 'Added to cart',
              last: 3000,
              sticky: !(productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper)
            });
            getCartJSON().then(function (cart) {
              if (cart) updateCartBubble(cart.item_count || 0);
            });
          }
        } else {
          window.location = safeGet(settings, 'routes.cart') || '/cart';
        }

        productFormEl && (productFormEl.error = false);
        try {
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
          }
        } catch (e8) {}
      })
      .catch(function () {
        showNotice(productFormEl, {
          target: (productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper) ? productFormEl.domNodes.errorWrapper : document.body,
          method: 'appendChild',
          type: 'warning',
          message: 'Could not add to cart.',
          last: 3000,
          sticky: !(productFormEl && productFormEl.domNodes && productFormEl.domNodes.errorWrapper)
        });
        productFormEl && (productFormEl.error = true);
      })
      .finally(function () {
        try {
          if (productFormEl && typeof productFormEl.toggleSpinner === 'function') productFormEl.toggleSpinner(false);
        } catch (e9) {}
        try {
          if (productFormEl && productFormEl.cart) {
            var itemsEl = productFormEl.cart.querySelector('m-cart-drawer-items');
            if (productFormEl.cart.classList.contains('m-cart--empty')) productFormEl.cart.classList.remove('m-cart--empty');
            if (itemsEl && itemsEl.classList.contains('m-cart--empty')) itemsEl.classList.remove('m-cart--empty');
          }
          if (productFormEl && productFormEl.cartPage && productFormEl.cartPage.classList && productFormEl.cartPage.classList.contains('m-cart--empty')) {
            productFormEl.cartPage.classList.remove('m-cart--empty');
          }
        } catch (e10) {}
      });
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var productFormEl = form.closest('product-form');
    if (!productFormEl) return;

    var checked = form.querySelectorAll('input[type="checkbox"][data-bb-addon]:checked');
    if (!checked || checked.length === 0) return; // let Minimog handle normal ATC

    // Intercept and fully replace Minimog submit
    e.preventDefault();
    // Stop other submit handlers (including Minimog's) from running
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    e.stopPropagation();

    handleMultiAdd(productFormEl, form, checked);
  }

  // Capture-phase submit interceptor
  document.addEventListener('submit', onSubmitCapture, true);
})();
